<template>
  <v-container>
    <v-row>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Nombre del personal</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="nameForm" ref="name">
              <BaseInput
                :value="personal.apaterno"
                @input="personal.apaterno = $event"
                :rules="required"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label> Apellido paterno <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseInput
                v-model="personal.amaterno"
                @input="personal.amaterno = $event"
                :rules="required"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>Apellido materno <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseInput
                v-model="personal.nombre"
                @input="personal.nombre = $event"
                :rules="required"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>Nombre <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseInput
                v-model="personal.segundoNombre"
                label="Segundo nombre"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              ></BaseInput>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Fecha de nacimiento</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="fechaNacimientoForm" ref="nacimiento">
              <BaseInput
                v-model="personal.fechaNacimiento"
                v-mask="'##/##/####'"
                :rules="dateRules"
                hint="Formato de fecha: DD/MM/YYYY"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>Fecha de nacimiento <span class="red--text">*</span> </template>
              </BaseInput>
            </v-form>
          </v-col>
          <v-col cols="12">
            <BaseInput :value="getAge(personal.fechaNacimiento)" readonly>
              <template #label>Edad</template>
            </BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Estado civil</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="estadoCivilForm" ref="civil">
              <BaseSelect
                v-model="personal.fk_idEstadoCivil"
                :items="estadoCivil"
                :rules="requiredSelect"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label> Estado civil <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Sexo</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="sexoForm" ref="sexo">
              <BaseSelect
                v-model="personal.fk_idSexo"
                :items="sexo"
                :rules="requiredSelect"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>Sexo <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col lg="8">
        <div class="text-h6 font-weight-bold">Grupo sanguíneo</div>
      </v-col>
      <v-col lg="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="grupoSanguineoForm" ref="sanguineo">
              <BaseSelect
                v-model="personal.fk_idCatGrupoSanguineo"
                :items="grupoSanguineo"
                :rules="requiredSelect"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>Grupo sanguíneo <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import BaseSelect from '../../../base/BaseSelect.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    BaseInput,
    BaseSelect,
  },
  data() {
    return {
      PERFILES,
      nameForm: false,
      fechaNacimientoForm: false,
      estadoCivilForm: false,
      sexoForm: false,
      grupoSanguineoForm: false,
      required: [(v) => !!v || 'Este campo es obligatorio'],
      requiredSelect: [(v) => !!v || 'Este campo es obligatorio'],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => /^\d{2}\/\d{2}\/\d{4}$/.test(v) || 'El formato de fecha debe ser DD/MM/YYYY',
      ],
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('estadoCivil', {
      estadoCivil: 'getEstadoCivil',
    }),
    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),
    ...mapGetters('grupoSanguineo', {
      grupoSanguineo: 'getGrupoSanguineo',
    }),
  },
  methods: {
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
    ...mapActions('personal', ['updatePersonal']),
    getAge(fechaNacimiento) {
      if (!fechaNacimiento) return ''
      const [dia, mes, anio] = fechaNacimiento.split('/')
      const birthDate = new Date(`${anio}-${mes}-${dia}`)
      const ageDifMs = Date.now() - birthDate.getTime()
      const ageDate = new Date(ageDifMs)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
  },
  async mounted() {
    if (!this.estadoCivil.length) await this.fetchEstadoCivil()
    if (!this.sexo.length) await this.fetchSexo()
    if (!this.grupoSanguineo.length) await this.fetchGrupoSanguineo()
  },
}
</script>
